// extracted by mini-css-extract-plugin
module.exports = {"QuantityButton":"AddArticleToTherapyModal_QuantityButton__YNsE1","QuantityInput":"AddArticleToTherapyModal_QuantityInput__W8n7F"};